import { Instance } from 'mobx-state-tree';
import model from './model';

const CertificateTemplateStore = model;

export interface ICertificateTemplateStore extends Instance<typeof CertificateTemplateStore> {}

export default CertificateTemplateStore;
